import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateViewerUser, type User, useViewer } from '@/entities/viewer';
import { api } from '@/shared/api';
import { changeLocale, isLocale, type Locale, SUPPORTED_LOCALES } from '@/shared/i18n';

export function LocaleSwitcher() {
  const { t, i18n } = useTranslation();
  const viewer = useViewer();
  const client = useQueryClient();

  const select = (locale: Locale) => {
    void changeLocale(locale);
    // Signed in: the choice is an account preference, not just this browser's.
    if (viewer.status === 'authenticated' && viewer.user.locale !== locale) {
      api.patch<User>('/v1/account', { locale }).then(
        (user) => {
          updateViewerUser(client, user);
        },
        () => undefined, // the UI already switched; the preference retries next time
      );
    }
  };
  return (
    <label>
      <span className="visually-hidden">{t('locale.label')}</span>
      <select
        value={i18n.resolvedLanguage}
        onChange={(event) => {
          if (isLocale(event.target.value)) select(event.target.value);
        }}
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {t(`locale.${locale}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
